/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import ExtensionService from 'live/services/extension'

interface ExportAnnotationButtonProps {
    items: AnnotationExportRegistryConfigObj[]
    onClick: () => void
    open: boolean
}

const ExportAnnotationButton: React.FC<ExportAnnotationButtonProps> = ({ items, open, onClick }) => {
    let buttonMessage = i18n('Share')
    if (items.length === 1) {
        const extensionName = ExtensionService.getAll()[items[0].type]?.name
        buttonMessage = i18n('Share to ') + (extensionName || items[0].name)
    }

    return (
        <DropdownButton
            aria-expanded={open}
            aria-haspopup="true"
            id="plugin-annotations_export-extension-point"
            role="button"
            type="button"
            className="plugin-annotations__text-button"
            onClick={onClick}
        >
            <i className="far fa-share-square" />
            {buttonMessage}
        </DropdownButton>
    )
}

const DropdownButton = styled.button`
    color: ${({ theme }) => theme['link-color']};
    max-width: 15em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    i {
        margin-right: 2px;
    }
`

export default ExportAnnotationButton
